import _ from 'lodash'

import utility from '@/mixins/utility'

class Pipeline {

  #data = {}

  #actions = []

  constructor(data={})
  {  
    this.#data = data

    if( data.actions )
      this.#actions = utility.methods.mapModels(data.actions, 'action')

  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active
  }

  get description()
  {
    return this.#data.description
  }

  get illustration()
  {
    return this.#data.illustration
  }

  get id()
  {
    return this.#data.id
  }

  get name()
  {
    return this.#data.name
  }


  /**
   * Relationships.
   */

  get actions()
  {
    return this.#actions
  }
    

  /**
   * Computed properties.
   */
  
  get progress()
  {
    if( !this.actions.length )
      return 0

    /**
     * @todo pipeline could have no final action?
     */
    const hasFinalAction = 1

    const actions = this.actions, 
          completed = _.filter(actions, { isCompleted: true }),
          value = ( completed.length + hasFinalAction ) / actions.length * 100

    return value
  }

  get isCompleted()
  {
    return this.progress === 100
  }
  
}

export default Pipeline